var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1424_76988",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1424_76988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.08008H24V20.0803H0V4.08008Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.07983H24V8.07966H0V6.07983ZM0 10.08H24V12.0798H0V10.08ZM0 14.0797H24V16.0795H0V14.0797ZM0 18.0798H24V20.0797H0V18.0798Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.08008H12V12.6956H0V4.08008Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67911 7.60952L4.48584 8.20409H3.86072L4.36655 8.57135L4.17328 9.16587L4.67911 8.7986L5.18461 9.16587L4.99139 8.57135L5.49722 8.20409H4.87205L4.67911 7.60952ZM4.87205 10.3496L4.67911 9.75513L4.48584 10.3496H3.86072L4.36655 10.717L4.17328 11.3115L4.67911 10.9442L5.18461 11.3115L4.99139 10.717L5.49722 10.3496H4.87205ZM2.23012 10.3496L2.03714 9.75513L1.84388 10.3496H1.21875L1.72458 10.717L1.53131 11.3115L2.03714 10.9442L2.54269 11.3115L2.34947 10.717L2.8552 10.3496H2.23012ZM2.03714 7.60952L1.84388 8.20409H1.21875L1.72458 8.57135L1.53131 9.16587L2.03714 8.7986L2.54269 9.16587L2.34947 8.57135L2.8552 8.20409H2.23012L2.03714 7.60952ZM4.67911 5.46387L4.48584 6.05848H3.86072L4.36655 6.42579L4.17328 7.0203L4.67911 6.65299L5.18461 7.0203L4.99139 6.42579L5.49722 6.05848H4.87205L4.67911 5.46387ZM2.03714 5.46387L1.84388 6.05848H1.21875L1.72458 6.42579L1.53131 7.0203L2.03714 6.65299L2.54269 7.0203L2.34947 6.42579L2.8552 6.05848H2.23012L2.03714 5.46387ZM7.32103 7.60952L7.12781 8.20409H6.50269L7.00847 8.57135L6.8153 9.16587L7.32103 8.7986L7.82662 9.16587L7.63336 8.57135L8.13919 8.20409H7.51406L7.32103 7.60952ZM7.51406 10.3496L7.32103 9.75513L7.12781 10.3496H6.50269L7.00847 10.717L6.8153 11.3115L7.32103 10.9442L7.82662 11.3115L7.63336 10.717L8.13919 10.3496H7.51406ZM10.156 10.3496L9.96305 9.75513L9.76978 10.3496H9.1447L9.65044 10.717L9.45722 11.3115L9.96305 10.9442L10.4686 11.3115L10.2753 10.717L10.7812 10.3496H10.156ZM9.96305 7.60952L9.76978 8.20409H9.1447L9.65044 8.57135L9.45722 9.16587L9.96305 8.7986L10.4686 9.16587L10.2753 8.57135L10.7812 8.20409H10.156L9.96305 7.60952ZM7.32103 5.46387L7.12781 6.05848H6.50269L7.00847 6.42579L6.8153 7.0203L7.32103 6.65299L7.82662 7.0203L7.63336 6.42579L8.13919 6.05848H7.51406L7.32103 5.46387ZM9.96305 5.46387L9.76978 6.05848H9.1447L9.65044 6.42579L9.45722 7.0203L9.96305 6.65299L10.4686 7.0203L10.2753 6.42579L10.7812 6.05848H10.156L9.96305 5.46387Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsa);
export default __webpack_public_path__ + "static/media/ic_usa.e7c2094e3d010c981793f1aeaeee7acd.svg";
export { ForwardRef as ReactComponent };